import { requests } from "../../helpers/api.services";
import { DASHBOARD_URL } from "../../helpers/api.routes";

export const LandingDashboardService = {
  getLanding: () => requests.get(`${DASHBOARD_URL}/landing`),
};
